export default __webpack_public_path__ + "static/media/search.d7863b7b.svg";